import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().trim().min(1, "Enter your email").email("Enter a valid email address"),
  password: z.string().min(1, "Enter your password"),
});

export type LoginValues = z.infer<typeof loginSchema>;

// Step 2 of the JSON login flow: the email one-time code. Length is intentionally
// lenient (4–8) since the backend's exact code length isn't pinned in the contract.
export const otpSchema = z.object({
  otp: z.string().trim().min(4, "Enter the code we emailed you").max(8, "That code looks too long"),
});

export type OtpValues = z.infer<typeof otpSchema>;
